module.exports = __webpack_public_path__ + "static/media/KTNO9683.9acb9aa6.JPG";